<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G5LwLf/tc-custom/9780802197863.jpg?1718081382986" alt="This image is the cover for the book Pleasing Hour"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pleasing Hour
      </h1>
      <p class="bookDescription body article font2">
        <b>The award-winning novel of a young American girl in France—hailed as “an impressive debut” that is “written with quiet, lyric forcefulness” (<i>Elle</i>)<i>.</i></b><br/>  <br/><b>A New York Times Notable Book</b><br/>  <br/> Young, inexperienced, and fleeing a terrible personal loss, Rosie—the new au pair to the Tivot family estate in France—finds herself ill at ease when trying to connect with Nicole, the cool, distant, and beautifully polished mother of the three children she cares for. There is something about the woman that both fascinates and unnerves Rosie.<br/>  <br/> The same is true of the rest of the Tivot clan. Nicole’s dissatisfied husband, Marc, and their children all seem to be caught in an unending struggle against each other for love and acceptance. Only when Rosie is sent to care for Nicole’s now-elderly guardian—the storyteller of the family’s secrets—does she finally discover the truth. There, Rosie will learn of a past darkened by war, duplicity, and a tragedy that still resonates in the Tivot’s lives . . .<br/>  <br/> With this novel of family, betrayal, and the naïveté of youth, Lily King has spun a story that is “powerful . . . splendid . . . [and all] so assured that it’s hard to believe the book itself is her debut” (<i>The New York Times Book Review</i>).<br/>  <br/> “Expertly constructed, full of surprises, superbly paced and sweetly sad, King’s book hardly reads like a first novel.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lily King
      </h2>
      
      <p class="authorDescription body article">Lily King&#39;s novel <I>Father of The Rain</I> (2010) was a <I>New York Times</I> Editors Choice, a <I>Publishers Weekly</I> Best Novel of the Year and winner of the 2010 New England Book Award for Fiction and the Maine Fiction Award. <I>The English Teacher</I> (2005) won the Maine Fiction Award, was a <I>Publishers Weekly</I> Top Ten Book of the Year and a<I> Chicago Tribune</I> Best Book of the Year. Her first novel, <I>The Pleasing Hour</I> (1999), won the B&amp;N Discover Award, was a New York Times Notable Book and an alternate for the PEN/Hemingway Award. King is also the recipient of a Whiting Writers&#39; Award. She lives with her husband and children in Maine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a8985a44